const GEOFENCE_FAILURE_MESSAGES = {
    no_osm_data: 'This property isn\'t mapped in OpenStreetMap yet.',
    timeout: 'OSM lookup timed out.',
    error: 'OSM lookup failed.',
    auth: 'Session expired — please log in again.',
    unknown: 'No boundary found automatically.',
};

export function geofenceFailureMessage(reason) {
    return GEOFENCE_FAILURE_MESSAGES[reason] ?? GEOFENCE_FAILURE_MESSAGES.unknown;
}

export const GEOFENCE_QUERY_FAILED =
    'Couldn\'t load parking boundary — use the Draw polygon tool on the toolbar.';

export const GEOFENCE_MAP_LOAD_FAILED =
    'Unable to load the map. Please refresh and try again.';

export const GEOFENCE_AUTOSAVE_FAILED =
    'Save failed — parking boundary changes may be lost.';
